<app-loading></app-loading>
<div class="sidenav-container">
  <!-- ★ <div class="sidenav-menu-area" *ngIf="!windowService.isChildScreen() && !windowService?.screenInfo?.forceHideMenu">
    <div class="system-logo">
      <img src="assets/images/main_logo.png">
    </div>
    <div class="panel-menu">
      <p-panelMenu [model]="menuProvider.getMenus()"></p-panelMenu>
    </div>
  </div> ★ -->
  <div class="sidenav-content-area">
    <router-outlet></router-outlet>
  </div>
</div>
